import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
import { tap } from 'rxjs';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { SnackbarService } from '~app/app/~shared/services/snackbar.service';
import { UserService } from '~app/app/~shared/services/user.service';

@Component({
  selector: 'change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrl: './change-password-form.component.scss'
})
export class ChangePasswordFormComponent extends BaseComponent {
  private userService = inject(UserService);
  private snackbarService = inject(SnackbarService);

  isLoading = signal(false);
  form = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8)
    ]),
    newPassword: new FormControl('', [Validators.required])
  });

  onSubmit(formDirective: FormGroupDirective): void {
    if (!this.form.valid) {
      return;
    }

    const { password, newPassword } = this.form.value;

    this.isLoading.set(true);

    this.userService
      .updatePassword({ password: password!, newPassword: newPassword! })
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: () => {
            formDirective.resetForm();

            this.snackbarService.open({
              text: 'Mot de passe mis à jour avec succès.',
              type: 'success'
            });

            this.isLoading.set(false);
          }
        })
      )
      .subscribe();
  }

  get formControls(): {
    password: FormControl<string | null>;
    newPassword: FormControl<string | null>;
  } {
    return this.form.controls;
  }
}
